import { makeStyles } from '@material-ui/core/styles';
import { Stepper, Step, StepLabel, StepContent, Typography } from '@mui/material';
import {useState} from 'react'
import {NextButton, PrevButton, TextButton} from '../1elements'
import Colors from '../../styling/Colors'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

const StepperBase = ({steps, getStepContent, finalAction, orientation, disabled, customFirstButton, setTemplate,isImport  }) => {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const isDownloadStep = activeStep === 0
    const isFinalStep = activeStep === steps.length - 1

    const skipDownload = () => {
        setTemplate()
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleDownloadTemplateNext = () => {
        customFirstButton()
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

    const handlePrev = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    if(isImport === true) {
        return (<div className={classes.root}>
        <Stepper activeStep={activeStep} orientation={orientation}>
            {steps.map((label, index) => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                    <StepContent>
                        <Typography>{getStepContent(index)}</Typography>
                        <div className={classes.actionsContainer}>
                            {/* previous buttons for the second and subsequent steps  */}
                            { (!isDownloadStep )
                                    && <PrevButton disabled={isDownloadStep} onClick={handlePrev} />}
                            {/* buttons for final step , buttons for download */}
                            {isFinalStep ? finalAction:
                            (isDownloadStep)
                                    ? <TextButton endIcon={<NavigateNextIcon/>} clickHandler={handleDownloadTemplateNext}>
                                        Download Template</TextButton>
                                    : <NextButton onClick={handleNext} disabled={disabled(activeStep)} />
                            }
                            { (isDownloadStep) &&
                                <NextButton onClick={skipDownload} /> }
                        </div>
                    </StepContent>
                </Step>
            ))}
        </Stepper>
    </div>)
    }else{
        return (
            <div className={classes.root}>
                <Stepper activeStep={activeStep} orientation={orientation}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                            <StepContent>
                                <Typography>{getStepContent(index)}</Typography>
                                <div className={classes.actionsContainer}>
                                    {activeStep !== 0
                                            && <PrevButton disabled={activeStep === 0} onClick={handlePrev} />}
                                    {activeStep === steps.length - 1
                                        ? finalAction
                                        : activeStep === 0 && customFirstButton
                                            ? <TextButton endIcon={<NavigateNextIcon/>} clickHandler={handleDownloadTemplateNext}>
                                                Download Template & Next</TextButton>
                                            : <NextButton onClick={handleNext} disabled={disabled(activeStep)} />
                                    }
                                </div>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </div>
        )
    }
}

export default StepperBase

const useStyles = makeStyles({
    root: {
        width: '100%',

        '& .MuiStepIcon-active, .MuiStepIcon-completed': {
            color: Colors.DARK_GREY  ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        },
        '& .MuiTypography-body2': {
            fontSize: '1.2rem'
        }
    },
    actionsContainer: {
        margin: '20px 0',
        '&>*': {
            marginTop: '10px',
            marginRight: '10px',
        }
    },
    resetContainer: {
        padding: '30px',
    },

});
